import { render, staticRenderFns } from "./MesaNewConta.vue?vue&type=template&id=02487ff2&scoped=true"
import script from "./MesaNewConta.vue?vue&type=script&lang=js"
export * from "./MesaNewConta.vue?vue&type=script&lang=js"
import style0 from "./MesaNewConta.vue?vue&type=style&index=0&id=02487ff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02487ff2",
  null
  
)

export default component.exports